interface TextAreaProps {
  id?: string;
  name?: string;
  placeholder: string;
  value?: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
  status?: 'default' | 'error' | 'success';
  errorMessage?: string;
}

export const TextArea = ({
  id,
  name,
  placeholder,
  value = '',
  onChange,
  isDisabled = false,
  status = 'default',
  errorMessage,
}: TextAreaProps) => {
  const statusClasses = {
    default:
      'border-secondary-100 hover:bg-secondary-50 focus-visible:border-secondary-200 focus-visible:shadow-[0_0_0_2px_white,0_0_0_4px_theme(colors.primary.500)] focus-visible:!bg-white',
    error:
      'border-error hover:bg-secondary-50 focus-visible:border-secondary-200 focus-visible:shadow-[0_0_0_2px_white,0_0_0_4px_theme(colors.primary.500)] focus-visible:!border-sm !border-md focus-visible:!bg-white',
    success:
      'border-success hover:bg-secondary-50 focus-visible:border-secondary-200 focus-visible:shadow-[0_0_0_2px_white,0_0_0_4px_theme(colors.primary.500)] focus-visible:!bg-white',
  }[status];

  const disabledClasses = isDisabled ? 'bg-secondary-100 cursor-not-allowed' : '';
  const errorBorderStyle = status === 'error' ? 'border-md' : 'border-sm';

  const wordCount = value ? value.length : 0;

  return (
    <div className="w-full">
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isDisabled}
        className={`border placeholder-secondary-200 bg-white outline-none focus:outline-none focus-visible:outline-none ${statusClasses} ${disabledClasses} ${errorBorderStyle} rounded-sm p-3 w-full block`}
      />
      <div className="flex justify-between items-center mt-xs">
        {errorMessage && <span className="text-xs text-error">{errorMessage}</span>}
        <span className="text-base text-secondary-700 text-right ml-auto">{wordCount}/1000</span>
      </div>
    </div>
  );
};
